module.exports = __webpack_public_path__ + "home-3-new.png?21c116f0e2055c156e70fc62d1d745d7";